/**
 * Leaflet地図関連の定数定義
 */

// 名古屋駅周辺の座標（デフォルト地図表示位置）
export const NAGOYA_STATION_COORDS: [number, number] = [35.1709, 136.8815];
export const DEFAULT_CENTER = NAGOYA_STATION_COORDS;

// OpenStreetMapタイル設定
export const OSM_TILE_LAYER = {
  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
};
